import IEventBinding from '../Interfaces/IEventBinding';
import Player        from '../Player';

const bindRootClickEvent = (player: Player): IEventBinding => {
    const handler = (): void => player.refs.root.focus();

    const {root} = player.refs;

    root.addEventListener('click', handler);

    const release = () => root.removeEventListener('click', handler);

    return {
        release
    };
};

export default bindRootClickEvent;